<div class="container">
  <div class="row location-related-data">
    <!-- <div class="row d-flex align-items-center service-header" [class]="'header-'+data.background"> -->
    <div class="row general-data d-flex align-items-center service-header">
      <div class="col-12 d-flex align-items-center service-header-font">
        <label class="header_panel titlePanel"> {{ data.identifier }}</label>
      </div>
      <!-- <div class="col-2 d-flex align-items-center service-header-font">
            <label class="header_panel titlePanel">
              <span class="locationRelatedIcon" [style]="'background-color: #'+data.pinColorHex+';'"></span>
            </label>
          </div> -->
    </div>
    <hr>
    <!-- <div [class]="'background-'+data.background"> -->
    <div>
      <label class="bold">No Order</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.noOrder }}</p>
      </div>
      <label class="bold">Identificador</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.identifier }}</p>
      </div>
      <label class="bold">Reparación</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.title }}</p>
      </div>
      <label class="bold">Descripción</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.description }}</p>
      </div>
      <label class="bold">Identificador Padre</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.identifierParent }}</p>
      </div>
      <label class="bold">Dirección</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.direction }}</p>
      </div>
      <label class="bold">Tiempo de Reparación</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.reparationTime }}</p>
      </div>
      <label class="bold">Horario de Garantía</label>
      <div class="row general-data d-flex align-items-center">
        <p>{{ data.warrantyTime }}</p>
      </div>

    </div>
  </div>
</div>
